var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapesSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.25C4 5.55964 4.55964 5 5.25 5H17.75C18.4404 5 19 5.55964 19 6.25V18.75C19 19.4404 18.4404 20 17.75 20H5.25C4.55964 20 4 19.4404 4 18.75V6.25ZM17.75 6.25H5.25V18.75H17.75V6.25Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesSquare);
export default __webpack_public_path__ + "static/media/shapes-square.c6514e6dc3ae95c627abd949220da9c1.svg";
export { ForwardRef as ReactComponent };